import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faRotateRight, faSliders } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import customSelectStyles from "../../../components/ui/customSelectStyles";
import { hasPermission } from "../../../utils/permissionUtils";

const UserRoleFilter = ({ onNewClick, onFilterChange }) => {
  const [advanced, setAdvanced] = useState(false);
  const [filters, setFilters] = useState({ keyword: "", role_id: "" });
  const debounceRef = useRef(null);

  const roleOptions = [
    { value: "admin", label: "Quản trị hệ thống" },
    { value: "teacher", label: "Giáo viên" },
    { value: "sale", label: "Nhân viên kinh doanh" },
  ];

  useEffect(() => () => clearTimeout(debounceRef.current), []);

  const emitFilter = (next, { immediate = false } = {}) => {
    clearTimeout(debounceRef.current);
    if (immediate) {
      onFilterChange(next);
      return;
    }
    debounceRef.current = setTimeout(() => onFilterChange(next), 300);
  };

  const handleChange = (e) => {
    const next = { ...filters, keyword: e.target.value };
    setFilters(next);
    emitFilter(next);
  };

  const refreshData = () => emitFilter({ ...filters }, { immediate: true });
  const clearFilters = () => {
    const cleared = { keyword: "", role_id: "" };
    setFilters(cleared);
    emitFilter(cleared, { immediate: true });
  };

  return (
    <div className="flex flex-col gap-2 mb-4">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <div className="flex flex-wrap gap-3 items-end">
          <input
            name="keyword"
            value={filters.keyword}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") refreshData();
            }}
            placeholder="Tìm theo tên hoặc mã NV..."
            className="border px-3 py-2 rounded w-72 max-w-full"
          />
          <button
            onClick={refreshData}
            className="h-[42px] w-[42px] border bg-white text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
            title="Làm mới"
          >
            <FontAwesomeIcon icon={faRotateRight} />
          </button>
          <button
            onClick={() => setAdvanced(!advanced)}
            className="h-[42px] w-[42px] border bg-white text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
            title={advanced ? "Ẩn lọc nâng cao" : "Lọc nâng cao"}
          >
            <FontAwesomeIcon icon={faSliders} />
          </button>
        </div>

        {hasPermission("settings.user_roles", "C") && (
          <button
            onClick={onNewClick}
            className="h-[42px] flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            <FontAwesomeIcon icon={faPlus} />
            Thêm phân quyền
          </button>
        )}
      </div>

      {advanced && (
        <div className="flex flex-wrap gap-3 mt-2">
          <div className="flex flex-col">
            <label className="text-sm text-gray-600 mb-1">Chọn quyền</label>
            <Select
              styles={customSelectStyles}
              options={roleOptions}
              value={roleOptions.find((r) => r.value === filters.role_id) || null}
              onChange={(opt) => {
                const next = { ...filters, role_id: opt?.value || "" };
                setFilters(next);
                emitFilter(next, { immediate: true });
              }}
              isClearable
            />
          </div>
          {filters.keyword || filters.role_id ? (
            <button
              onClick={clearFilters}
              className="h-[42px] w-[42px] border bg-white text-gray-600 rounded hover:bg-gray-200 flex items-center justify-center"
            >
              ✕
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default UserRoleFilter;
